"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _uiKit = require("@devsta/ui-kit"),
    _AddonsContext = _interopRequireDefault(require("../context/AddonsContext")),
    _Error = _interopRequireDefault(require("../../Error")),
    _utils = require("../utils"),
    _constants = _interopRequireDefault(require("../constants"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function isEqual(a, b) {
  var c = (0, _slicedToArray2["default"])(a, 3),
      d = c[0],
      e = c[1],
      f = c[2],
      g = (0, _slicedToArray2["default"])(b, 3),
      h = g[0],
      i = g[1],
      j = g[2];
  return d === h && f === j && (0, _lodash["default"])(e, i);
}

var AddonsProvider = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.getProviderValue = (0, _memoizeOne["default"])(function (a, b, c) {
      var d = (0, _constants["default"])(),
          e = d.DURATIONS,
          f = d.RUSH_EDIT,
          g = d.CHROMA_KEY,
          h = d.VIDEO_OUTPUT,
          i = d.ASPECT_RATIOS,
          j = d.CAPTIONS,
          k = d.CAPTION_SAMPLES;
      if (!c) return {
        state: {
          loading: !0
        }
      };
      var l = g({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          m = e({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          n = f({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          o = h({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          p = j({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          q = (0, _utils.getAddonsCost)({
        billingEntityCode: a,
        includedAddons: b,
        addonsCosts: c
      }),
          r = (0, _utils.getFormattedAddon)({
        CHROMA_KEY: l,
        DURATIONS: m,
        RUSH_EDIT: n,
        VIDEO_OUTPUT: o
      }),
          s = (0, _utils.getCaptions)(p),
          t = (0, _utils.getCurrencySymbol)(a);
      return {
        actions: {
          getAddonsCost: q,
          getCostForAddon: _utils.getCostForAddon,
          getAddonValue: _utils.getAddonValue,
          getAddonLabel: _utils.getAddonLabel,
          getFormattedAddon: r,
          getCaptions: s,
          mergeAddon: _utils.mergeAddon,
          getCurrencySymbol: t
        },
        constants: {
          ASPECT_RATIOS: i,
          DURATIONS: m,
          RUSH_EDIT: n,
          CAPTIONS: p,
          VIDEO_OUTPUT: o,
          CAPTION_SAMPLES: k,
          CHROMA_KEY: l
        },
        state: {
          loading: !1
        }
      };
    }, isEqual), d.fetchAddons = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props.getAddonsByType, a.next = 3, b();

            case 3:
              if (c = a.sent, e = c.error, f = c.data, !e && f) {
                a.next = 8;
                break;
              }

              return a.abrupt("return", void d.setState({
                error: !0
              }));

            case 8:
              d.setState({
                addonsCosts: f.getAddonsByType
              });

            case 9:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), d.state = {
      addonsCosts: null
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchAddons();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.addonsCosts,
          c = a.error,
          d = this.props,
          e = d.billingEntityCode,
          f = d.includedAddons,
          g = d.children,
          h = d.loaderProps,
          i = d.showLoader,
          j = d.renderChildWhenLoading;
      return c ? _react["default"].createElement(_Error["default"], null) : b || j ? _react["default"].createElement(_AddonsContext["default"].Provider, {
        value: this.getProviderValue(e, f, b)
      }, g) : i ? _react["default"].createElement(_uiKit.Loader, h) : null;
    }
  }]), b;
}(_react.Component);

AddonsProvider.defaultProps = {
  loaderProps: {},
  showLoader: !0
};
var _default = AddonsProvider;
exports["default"] = _default;